import PortfolioMaster from '../../assests/images/PortfolioMasterDataIllustration.svg';
import PortfolioSummary from '../../assests/images/PortfolioSummary.png';
import PortfolioDetailedView from '../../assests/images/PortfolioDetailedView.png';
import test from '../../assests/images/test.svg';
import CustomerView2 from '../../assests/images/CustomerView2.png';

export const readinessCards = [
{
    id: 'teams',
    cardHeader: 'Teams',
    cardContent:
      // eslint-disable-next-line max-len
      'Create and view teams to facilitate optimisation',
    cardButton: 'View',
    cardImage: CustomerView2,
    cardText: 'customer view',
    actionLink: '/setup-team',
    showStatus: true,
    e2eTask: 'Setup Team',
    isCardDisabled: false
    //'/readiness/teams'
  },
  {
    id: 'calendar',
    cardHeader: 'Calendar',
    cardContent: 'Schedule and manage important milestones',
    cardButton: 'View',
    cardImage: CustomerView2,
    cardText: 'customer view',
    actionLink: '/readiness/calendar',
    showStatus: false,
    isCardDisabled: false
  },
  {
    id: 'manualUpload',
    cardHeader: 'PO Manual Data Upload',
    cardContent: 'Upload Product Master Data, Region/Channel mapping and Sales, Profit, Waste KPIs',
    cardButton: 'View',
    cardImage: CustomerView2,
    cardText: 'customer view',
    actionLink: '/upload',
    e2eTask: 'Prep Master File',
    showStatus: true,
    isCardDisabled: false
  },
  
  // {
  //   id: 'decisionMakingRules',
  //   cardHeader: 'Decision Making Rules',
  //   cardContent: '	Create guidelines to govern decisions to ensure clarity',
  //   cardButton: 'View',
  //   cardImage: test,
  //   cardText: 'customer view',
  //   actionLink: '/readiness/decision-making-rules',
  //   showStatus: false,
  //   isCardDisabled: true
  //   // actionLink:
  //   //   userRole && userRole.indexOf(GENERAL_USER) !== -1
  //   //     ? '/readiness/decision-making-rules-view-only'
  //   //     : '/readiness/decision-making-rules', // Conditional actionLink
  // },
  // {
  //   id: 'portfolioMetrics',
  //   cardHeader: 'Portfolio Metrics Master',
  //   cardContent: 'Explore KPI availability for your selections',
  //   cardButton: 'View',
  //   cardImage: PortfolioDetailedView,
  //   cardText: 'portfolio metrics master',
  //   actionLink: '/cycle-analytics/portfolio-details',
  //   isCardDisabled: false,
  //   navigateState: 'metrics_master'
  // },
  {
      id: 'portfolioMaster',
      cardHeader: 'Portfolio Master Data',
      cardContent: 'Maintain and manage centralized repository of SKU',
      cardButton: 'View',
      cardImage: PortfolioMaster,
      cardText: 'portolio master view',
      actionLink: '/portfolio/master-data',
      e2eTask: 'Prep Master File',
      showStatus: true,
      isCardDisabled: false
  },
  {
      id: 'cycleTrigger',
      cardHeader: 'Cycle Trigger',
      cardContent: 'Initate and trigger a cycle to get optimized results',
      cardButton: 'View',
      cardImage: test,
      cardText: 'customer view',
      actionLink: '/portfolio/cycle-trigger',
      e2eTask: 'Trigger Cycle',
      showStatus: true,
      isCardDisabled: false
    }
];

export const cycleTriggerCards = [
  {
    id: 'portfolioSummary',
    cardHeader: 'Portfolio Summary',
    cardContent: 'View Portfolio Quadrant Summary',
    cardButton: 'View',
    cardImage: PortfolioSummary,
    cardText: 'portfolio summary',
    actionLink: '/cycle-analytics/portfolio-details', //'/cycle-analytics/portfolio-summary',
    showStatus: false,
    isCardDisabled: false,
    navigateState: 'summary'
  },
  {
    id: 'portfolioDetail',
    cardHeader: 'Portfolio Detail View',
    cardContent: 'View insights at SKU level',
    cardButton: 'View',
    cardImage: PortfolioDetailedView,
    cardText: 'portfolio detailed',
    actionLink: '/cycle-analytics/portfolio-details',
    showStatus: false,
    isCardDisabled: false,
    navigateState: 'detail'
  },
];

export const brandInsightCards = [
  {
    id: 'marketInsights',
    cardHeader: 'Brand Insights',
    cardContent: 'View insights at a brand level',
    cardButton: 'View',
    cardImage: PortfolioDetailedView,
    cardText: 'portfolio detailed',
    actionLink: '/cycle-analytics/portfolio-details', 
    showStatus: false,
    isCardDisabled: false,
    navigateState: 'brand'
  },
  {
    id: 'regional-portfolio-comparison',
    cardHeader: 'Portfolio Comparison',
    cardContent: 'View insights at region/channel level',
    cardButton: 'View',
    cardImage: PortfolioDetailedView,
    cardText: 'regional portfolio view',
    actionLink: '/cycle-analytics/portfolio-details',
    showStatus: false,
    isCardDisabled: false,
    navigateState: 'comparison'
  },
  {
    id: 'customer',
    cardHeader: 'Customer Insights',
    cardContent: 'View portfolio performance across customers',
    cardButton: 'View',
    cardImage: PortfolioDetailedView,
    cardText: 'Customer Insights',
    actionLink: '/cycle-analytics/portfolio-details', 
    showStatus: false,
    isCardDisabled: false,
    navigateState: 'customer'
  },
]
export const alignmentAndAction = [
  {
    id: 'feedback',
    cardHeader: 'Feedback & Voting',
    cardContent:
      'Gather and organize feedback from steering committee, functional stakeholder and regional leaders',
    cardButton: 'View',
    cardImage: PortfolioSummary,
    cardText: 'portfolio summary',
    actionLink: '/alignment-action/feedback-collation',
    e2eTask: ['Steering Reco', 'Functional Feedback', 'Regional Decisions'],
    showStatus: true,
    isCardDisabled: false
  },
  {
    id: 'decisionMakingCentral',
    cardHeader: 'Decision Making Central',
    cardContent: 'View consolidated information to make effective decision for optimization',
    cardButton: 'View',
    cardImage: PortfolioDetailedView,
    cardText: 'portfolio detailed',
    actionLink: '/alignment-action/decision-making-central',
    e2eTask: ['Final Decisions', 'Execute Actions'],
    showStatus: true,
    isCardDisabled: false
  },
  {
    id: 'cycleActionSummary',
    cardHeader: 'Cycle Action Summary',
    cardContent: 'Outline impact of decisions taken',
    cardButton: 'View',
    cardImage: PortfolioDetailedView,
    cardText: 'portfolio detailed',
    actionLink: '/alignment-action/cycle-action-summary',
    showStatus: false,
    isCardDisabled: true
  }
];
